/**
 * Encensoria — Cookie Banner Shopify natif (override complet via JS inline)
 * - Texte minimal légal + brand (titre supprimé, paragraphe court)
 * - Centré horizontalement bottom desktop + mobile
 * - Compact (max-width 540px desktop, 92vw mobile)
 * - Boutons inline horizontal (Refuser + Accepter côte à côte) + Préférences en text-link
 */
(function() {
  'use strict';

  var TEXT = 'Encensoria utilise des cookies pour améliorer votre expérience zen sur le site. ';
  var customized = false;

  function applyStyle(el, css) {
    if (!el) return;
    for (var k in css) {
      el.style.setProperty(k, css[k], 'important');
    }
  }

  function customizeBanner() {
    if (customized) return true;
    var banner = document.getElementById('shopify-pc__banner');
    if (!banner) return false;

    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    // ===== TEXTE =====
    var title = document.getElementById('shopify-pc__banner__body-title');
    if (title) title.style.setProperty('display', 'none', 'important');

    var body = banner.querySelector('.shopify-pc__banner__body');
    var policyLink = document.getElementById('shopify-pc__banner__body-policy-link');
    if (body && policyLink) {
      var para = body.querySelector('p');
      if (para) {
        para.innerHTML = TEXT + policyLink.outerHTML;
      }
    }

    // ===== WRAPPER BANNER : centré bottom + compact =====
    applyStyle(banner, {
      'position': 'fixed',
      'bottom': '16px',
      'left': '50%',
      'top': 'auto',
      'right': 'auto',
      'transform': 'translateX(-50%)',
      'margin': '0',
      'background': '#2B2B2B',
      'background-color': '#2B2B2B',
      'border': '1px solid rgba(212, 162, 118, 0.35)',
      'border-radius': '12px',
      'color': '#F5F0EB',
      'font-family': "'Montserrat', sans-serif",
      'box-shadow': '0 8px 32px rgba(0, 0, 0, 0.4)',
      'padding': isMobile ? '0.85rem 1rem' : '0.7rem 1.1rem',
      'max-width': isMobile ? '92vw' : '500px',
      'width': isMobile ? '92vw' : 'auto',
      'box-sizing': 'border-box',
      'z-index': '9999'
    });

    // Wrapper interne : column desktop ET mobile, gap réduit
    var wrapper = banner.querySelector('.shopify-pc__banner__wrapper');
    applyStyle(wrapper, {
      'display': 'flex',
      'flex-direction': 'column',
      'gap': isMobile ? '0.5rem' : '0.55rem',
      'align-items': 'center',
      'margin': '0',
      'padding': '0',
      'width': '100%'
    });

    // Body
    applyStyle(body, {
      'flex': '1 1 auto',
      'margin': '0',
      'padding': '0',
      'text-align': 'center',
      'width': '100%'
    });

    // Paragraphe — centré
    var p = body && body.querySelector('p');
    applyStyle(p, {
      'color': 'rgba(245, 240, 235, 0.9)',
      'font-family': "'Montserrat', sans-serif",
      'font-size': isMobile ? '12.5px' : '13px',
      'line-height': '1.5',
      'font-weight': '400',
      'margin': '0',
      'padding': '0',
      'text-align': 'center'
    });

    // Lien politique
    applyStyle(policyLink, {
      'color': '#D4A276',
      'text-decoration': 'underline',
      'text-underline-offset': '3px',
      'font-weight': '500',
      'background': 'transparent',
      'margin-left': '0.2rem'
    });

    // Container boutons — inline horizontal centré (desktop) / grid (mobile)
    var btnsWrap = banner.querySelector('.shopify-pc__banner__btns');
    if (isMobile) {
      applyStyle(btnsWrap, {
        'display': 'grid',
        'grid-template-columns': '1fr 1fr',
        'gap': '0.4rem',
        'width': '100%',
        'margin': '0',
        'padding': '0'
      });
    } else {
      applyStyle(btnsWrap, {
        'display': 'flex',
        'flex-direction': 'row',
        'gap': '0.4rem 0.5rem',
        'flex-wrap': 'wrap',
        'align-items': 'center',
        'justify-content': 'center',
        'margin': '0',
        'padding': '0',
        'width': '100%'
      });
    }

    // Boutons : reset commun (compacts, taille réduite)
    var allBtns = banner.querySelectorAll('button');
    allBtns.forEach(function(b) {
      applyStyle(b, {
        'font-family': "'Poppins', sans-serif",
        'font-size': isMobile ? '12.5px' : '12px',
        'font-weight': '500',
        'letter-spacing': '0.01em',
        'padding': isMobile ? '0.55rem 0.4rem' : '0.4rem 0.7rem',
        'border-radius': '5px',
        'cursor': 'pointer',
        'transition': 'all 0.2s ease',
        'min-height': isMobile ? '34px' : '30px',
        'white-space': 'nowrap',
        'outline': 'none',
        'text-shadow': 'none',
        'flex': '0 0 auto'
      });
    });

    // Préférences : text-link doré mini, sous les boutons (full-width, centré)
    var btnPrefs = document.getElementById('shopify-pc__banner__btn-manage-prefs');
    applyStyle(btnPrefs, {
      'background': 'transparent',
      'background-color': 'transparent',
      'color': '#D4A276',
      'border': 'none',
      'text-decoration': 'underline',
      'text-underline-offset': '3px',
      'padding': isMobile ? '0.25rem 0.4rem' : '0.25rem 0.4rem',
      'font-weight': '400',
      'font-size': isMobile ? '11.5px' : '11px',
      'min-height': 'auto',
      'order': isMobile ? '3' : '99',
      'grid-column': isMobile ? '1 / -1' : 'auto',
      'flex': isMobile ? '0 0 auto' : '0 0 100%',
      'text-align': 'center',
      'margin-top': isMobile ? '0' : '0.15rem'
    });

    // Refuser : outlined doré (gauche)
    var btnDecline = document.getElementById('shopify-pc__banner__btn-decline');
    applyStyle(btnDecline, {
      'background': 'transparent',
      'background-color': 'transparent',
      'color': '#D4A276',
      'border': '1px solid #D4A276',
      'order': '1',
      'width': isMobile ? '100%' : 'auto',
      'min-width': isMobile ? '0' : '90px'
    });

    // Accepter : filled doré (droite, signature)
    var btnAccept = document.getElementById('shopify-pc__banner__btn-accept');
    applyStyle(btnAccept, {
      'background': '#D4A276',
      'background-color': '#D4A276',
      'color': '#2B2B2B',
      'border': '1px solid #D4A276',
      'font-weight': '600',
      'box-shadow': '0 2px 8px rgba(212, 162, 118, 0.18)',
      'order': '2',
      'width': isMobile ? '100%' : 'auto',
      'min-width': isMobile ? '0' : '95px'
    });

    customized = true;
    return true;
  }

  // ===== MODAL PRÉFÉRENCES — inject style tag dans le head (après Shopify styles) =====
  function injectPrefsStyle() {
    if (document.getElementById('encensoria-cookie-prefs-style')) return;
    var st = document.createElement('style');
    st.id = 'encensoria-cookie-prefs-style';
    st.textContent = [
      // Overlay
      '.shopify-pc__prefs__overlay, #shopify-pc__prefs__overlay {',
      '  background: rgba(43, 43, 43, 0.75) !important;',
      '  backdrop-filter: blur(3px) !important;',
      '}',
      // Modal dialog
      '.shopify-pc__prefs__dialog, #shopify-pc__prefs__dialog {',
      '  background: #2B2B2B !important;',
      '  color: #F5F0EB !important;',
      '  border: 1px solid rgba(212, 162, 118, 0.3) !important;',
      '  border-radius: 12px !important;',
      '  font-family: "Montserrat", sans-serif !important;',
      '  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5) !important;',
      '}',
      // Tous les éléments texte du modal — force clair
      '.shopify-pc__prefs__dialog, .shopify-pc__prefs__dialog *, ',
      '#shopify-pc__prefs__dialog, #shopify-pc__prefs__dialog * {',
      '  color: #F5F0EB !important;',
      '}',
      // Headings
      '.shopify-pc__prefs__dialog h1, .shopify-pc__prefs__dialog h2, .shopify-pc__prefs__dialog h3,',
      '#shopify-pc__prefs__dialog h1, #shopify-pc__prefs__dialog h2, #shopify-pc__prefs__dialog h3 {',
      '  font-family: "Poppins", sans-serif !important;',
      '  font-weight: 500 !important;',
      '  color: #F5F0EB !important;',
      '}',
      // Texte secondaire / explications
      '.shopify-pc__prefs__intro, .shopify-pc__prefs__intro p, .shopify-pc__prefs__intro-main,',
      '.shopify-pc__prefs__intro-explain, .shopify-pc__prefs__intro-explain *,',
      '.shopify-pc__prefs__option, .shopify-pc__prefs__option p {',
      '  color: rgba(245, 240, 235, 0.85) !important;',
      '  font-size: 14px !important;',
      '  line-height: 1.6 !important;',
      '}',
      // Liens
      '.shopify-pc__prefs__dialog a, #shopify-pc__prefs__dialog a {',
      '  color: #D4A276 !important;',
      '  text-decoration: underline !important;',
      '  text-underline-offset: 3px !important;',
      '}',
      '.shopify-pc__prefs__dialog a:hover { color: #fff !important; }',
      // Bordures entre options
      '.shopify-pc__prefs__option {',
      '  border-bottom: 1px solid rgba(212, 162, 118, 0.15) !important;',
      '  padding: 1rem 0 !important;',
      '}',
      // Labels
      '.shopify-pc__prefs__option label, .shopify-pc__prefs__options label {',
      '  color: #F5F0EB !important;',
      '  font-weight: 500 !important;',
      '}',
      // Checkboxes — accent doré
      '.shopify-pc__prefs__dialog input[type="checkbox"],',
      '#shopify-pc__prefs__dialog input[type="checkbox"],',
      '[id*="shopify-pc__prefs"] input[type="checkbox"] {',
      '  accent-color: #D4A276 !important;',
      '}',
      // Bouton Accepter dans header
      '#shopify-pc__prefs__header-accept, #shopify-pc__prefs__header-save {',
      '  background: #D4A276 !important;',
      '  background-color: #D4A276 !important;',
      '  color: #2B2B2B !important;',
      '  border: 1px solid #D4A276 !important;',
      '  font-weight: 600 !important;',
      '  font-family: "Poppins", sans-serif !important;',
      '  border-radius: 6px !important;',
      '  padding: 0.55rem 1.2rem !important;',
      '  cursor: pointer !important;',
      '  font-size: 13px !important;',
      '}',
      '#shopify-pc__prefs__header-accept:hover, #shopify-pc__prefs__header-save:hover {',
      '  background: #C99566 !important;',
      '}',
      // Bouton Refuser dans header
      '#shopify-pc__prefs__header-decline {',
      '  background: transparent !important;',
      '  background-color: transparent !important;',
      '  color: #D4A276 !important;',
      '  border: 1px solid #D4A276 !important;',
      '  font-family: "Poppins", sans-serif !important;',
      '  border-radius: 6px !important;',
      '  padding: 0.55rem 1.2rem !important;',
      '  cursor: pointer !important;',
      '  font-size: 13px !important;',
      '}',
      '#shopify-pc__prefs__header-decline:hover {',
      '  background: rgba(212, 162, 118, 0.1) !important;',
      '  color: #fff !important;',
      '}',
      // Bouton fermer (croix)
      '#shopify-pc__prefs__header-close {',
      '  color: #D4A276 !important;',
      '  background: transparent !important;',
      '}',
      '#shopify-pc__prefs__header-close:hover {',
      '  color: #fff !important;',
      '}',
      // Scrollable area
      '.shopify-pc__prefs__scrollable {',
      '  background: transparent !important;',
      '}'
    ].join('\n');
    // On l'inject à la fin du head pour qu'il soit APRÈS le style Shopify natif
    document.head.appendChild(st);
  }
  injectPrefsStyle();

  // Re-apply on resize (au cas où mobile <-> desktop)
  var resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      customized = false;
      customizeBanner();
    }, 200);
  });

  if (customizeBanner()) return;

  var observer = new MutationObserver(function() {
    if (customizeBanner()) {
      observer.disconnect();
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  setTimeout(function() {
    try { observer.disconnect(); } catch (e) {}
  }, 30000);
})();
